import { Controller } from 'stimulus';
import $ from 'jquery';
export default class extends Controller {

    static targets = ['url', 'allCheckboxes', 'textarea', 'tooltip', 'loadingImage', 'transmissionNumber','cornerstoneViewer', 'octViewer', 'igmpViewer', 'toggle','input','scopeAi','migViewer']

    async initialize() {

        this.transmissionsSaveUrl = document.location.origin + this.data.get("transmissionsSubmitPath") + ".json";
        let baseUrl = this.data.get("transmissionsApiUrl");
        this.clientId = this.data.get("clientId");
        this.clientSecret = this.data.get("clientSecret");
        this.transDate = this.data.get("transDate");
        this.studyCode = this.data.get("studyCode");
        this.url = baseUrl + "?trans_date=" + this.transDate + "&study_code=" + this.studyCode;
        if (this.hasLoadingImageTarget) {
            this.hideLoader();
        }
    }
    connect() {
    this.allViewers = [];

    if (this.hasCornerstoneViewerTarget) this.allViewers.push(this.cornerstoneViewerTarget);
    if (this.hasOctViewerTarget) this.allViewers.push(this.octViewerTarget);
    if (this.hasMigViewerTarget) this.allViewers.push(this.migViewerTarget);
    if (this.hasIgmpViewerTarget) this.allViewers.push(this.igmpViewerTarget);
    if (this.hasScopeAiTarget) this.allViewers.push(this.scopeAiTarget);

    this.allViewers.forEach((el) => {
        el.addEventListener('change', this.toggleCheckboxes.bind(this));
    });

    $('.select2-search-box').select2({ width: '100%' });
    // Event listener for when the dropdown is opened
    $('.select2-search-box').on('select2:open', function() {
        // Use a timeout to ensure the focus is set correctly
        setTimeout(function() {
        var searchField = $('.select2-search__field');
        if (searchField.length > 0) {
            searchField[0].focus();
        }
        }, 0); 
    });
     
        $(".bcc_email").select2({
            tags: true,
            tokenSeparators: [',', ' ']
        });
        $(".value").select2({
            tags: true,
            tokenSeparators: [',', ' ']
        });
    }

    update_visit_order(event) {
        const input = event.target
        const visitId = input.dataset.id
        const value = input.value
        const statusEl = document.getElementById(`status-${visitId}`)

        // Show loading
        statusEl.innerHTML = "⏳"
        

        fetch(`/studies/${this.data.get("studyId")}/visits/${visitId}/update_sort_order`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
        },
        body: JSON.stringify({ sort_order: value })
        })
        .then(response => {
        if (response.ok) {
        statusEl.innerHTML = "✅"
        } else {
        statusEl.innerHTML = "❌"
        }

        setTimeout(() => {
        statusEl.innerHTML = ""
        }, 1000)
    })
    .catch(() => {
        statusEl.innerHTML = "❌"

        setTimeout(() => {
        statusEl.innerHTML = ""
        }, 1000)
    })
    }
  
    toggleCheckboxes(event) {
    const clicked = event.target;

    if (clicked.checked) {
        this.allViewers.forEach((el) => {
        if (el !== clicked) {
            el.checked = false;
        }
        });
    }
    }

    loadwindow() {
        this.url = this.urlTarget.getAttribute('data-link');
        window.location = this.url;
    }

    selectAllImages() {
        const selected = document.getElementsByClassName("select_all_stack_images")[0].checked;
        var all_images = this.allCheckboxesTarget.querySelectorAll('input[type="checkbox"]');
        for (var i = 0; i < all_images.length; i++) {
            // And stick the checked ones onto an array...
            if (selected) {
                all_images[i].checked = true;
            } else {
                all_images[i].checked = false;
            }
        }
    }
   
    
    confirmDelete(event) {
        event.preventDefault();
        const linkElement = event.currentTarget;

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, do it!',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                window.location = linkElement.getAttribute('href');
            }
        });
    }
    confirmRemovalStudyUser(event) {
        event.preventDefault();
        const target = event.target.closest("tr");

        Swal.fire({
            title: "Are you sure?",
            text: "You want to remove the user from this study?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, remove",
        }).then((result) => {
            if (result.isConfirmed) {
                const url = this.element.getAttribute("href");
                Rails.ajax({
                    type: "DELETE",
                    url: url,
                    dataType: "json",
                    success: () => {
                        Swal.fire("Removed!", "The user has been removed from the study.", "success");
                        if (target) {
                            target.remove();
                        }
                    },
                    error: () => {
                        Swal.fire("Can't Removed", "You cannot delete the owner of the study", "error");
                    }
                });
            }
        });
    }
    toggleTextarea() {
        const comments = document.getElementsByClassName("show_hide_comments")[0]
        if (comments.style.display === 'none') {
            comments.style.display = 'block';
        } else {
            comments.style.display = 'none'
        }
    }
    showRejectedForm(event) {
        event.preventDefault();
        let each_form = document.getElementById("show_single_form_" + event.currentTarget.id);
        if (each_form.classList.contains('hidden')) {
            each_form.classList.remove("hidden");
        }
        else {
            each_form.classList.add("hidden");
        }
    }
    grandfatherReject(event) {
        document.getElementById("grandfathering_certification_form").style.display = "none";
        let reject_form = document.getElementById("grandfathering_rejected_form")
        if (reject_form.style.display === "none") {
            reject_form.style.display = "block";
        }
        event.preventDefault();
        // To import transmissions from the OCAP
    }
    importTransmissions() {
        this.showLoader();
        this.getTransmissions()
            .then(() => {
                this.hideLoader();
                window.location.reload();
            })
            .catch((error) => {
                // Handle any errors, and hide the loader in case of error as well
                console.error("Error occurred during import:", error);
                this.hideLoader();
            });
    }

    getTransmissions() {
        return fetch(this.url, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Client-Id": this.clientId,
                "Client-Secret": this.clientSecret,
            },
            method: "GET",
        })
            .then((response) => response.json())
            .then((result) => {
                return this.pushTransmissions(result.data);
            });
    }

    pushTransmissions(responseData) {
        return fetch(this.transmissionsSaveUrl, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "X-CSRF-Token": document.head
                    .querySelector('meta[name="csrf-token"]')
                    .getAttribute("content"),
            },
            method: "POST",
            body: JSON.stringify({
                import_data: {
                    transmissions: responseData.data,
                },
            }),
        });
    }

    // copy transmission number

    copy(event) {

        const transmissionNumber = event.currentTarget.querySelector('[data-common-script-target="transmissionNumber"]').textContent.trim();
        const tooltip = event.currentTarget.querySelector('[data-common-script-target="tooltip"]');
        navigator.clipboard.writeText(transmissionNumber)
            .then(() => {
                tooltip.textContent = 'Copied!';
                setTimeout(() => {
                    tooltip.textContent = 'Copy to clipboard';
                }, 1000);
            })
            .catch((error) => {
                console.error('Copying to clipboard failed:', error);
            });
    }

    showLoader() {
        this.loadingImageTarget.classList.add("visible");
    }

    hideLoader() {
        this.loadingImageTarget.classList.remove("visible");
    }

    switchstatus(event){
        event.preventDefault();
        const url = this.element.dataset.switchUrl;
        const status = this.element.dataset.status;
        const message = status === 'true' ? 'unlock' : 'lock'

        Swal.fire({
            title: `Are you sure, you want to ${message} this user?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: `Yes!`
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then(response => {
                    // Check if response is okay
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    Swal.fire({
                        title: 'Success!',
                        text: data.message,
                        icon: 'success',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            location.reload();
                        }
                    });
                }) 
            }
        });    
    }

    // Badge CSS classes for internal status (must match query_managements_helper internal_status_badge_class)
    static internalStatusBadgeClasses = {
        '0': 'bg-gray-200 text-gray-800',
        '1': 'bg-blue-200 text-blue-800',
        '2': 'bg-orange-200 text-orange-800',
        '3': 'bg-green-200 text-green-800'
    };

    updateInternalStatus(event) {
        event.preventDefault();
        event.stopPropagation();
        const select = event.target;
        const url = select.dataset.updateInternalStatusUrl;
        if (!url) return;

        // Update badge color immediately when user changes selection
        this.applyInternalStatusBadge(select, select.value);

        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        const body = new URLSearchParams({
            internal_status: select.value,
            authenticity_token: csrfToken || ''
        });

        fetch(url, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'X-CSRF-Token': csrfToken || '',
                'Accept': 'application/json'
            },
            body: body.toString()
        })
            .then((response) => response.json().then((data) => ({ response, data })).catch(() => ({ response, data: null })))
            .then(({ response, data }) => {
                if (response.ok) {
                    if (typeof Swal !== 'undefined') {
                        Swal.fire({ icon: 'success', title: 'Success', text: 'Internal status updated successfully', timer: 2000, showConfirmButton: false });
                    } else if (typeof toastr !== 'undefined') {
                        toastr.success("Internal status updated successfully");
                    }
                } else {
                    if (typeof Swal !== 'undefined') {
                        Swal.fire({ icon: 'error', title: 'Error', text: (data && data.error) || 'Failed to update internal status' });
                    } else if (typeof toastr !== 'undefined') {
                        toastr.error("Failed to update internal status");
                    }
                }
            })
            .catch(() => {
                if (typeof Swal !== 'undefined') {
                    Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to update internal status' });
                } else if (typeof toastr !== 'undefined') {
                    toastr.error("Failed to update internal status");
                }
            });
    }

    applyInternalStatusBadge(select, value) {
        const baseClasses = 'internal-status-select px-2 py-1 rounded-full text-xs font-semibold border-0 cursor-pointer';
        const badgeClass = this.constructor.internalStatusBadgeClasses[String(value)] || this.constructor.internalStatusBadgeClasses['0'];
        select.className = baseClasses + ' ' + badgeClass;
    }



}
